
import styled from 'styled-components'

export const MobilePosts = styled.div`
background-color: #101010;
overflow: scroll;
a {
    font-family: "Baskerville Old Face", "Times New Roman", serif, sans-serif;
    display: block;
    text-transform: none;
    font-size: 24px;
    padding: 0 20px;
    margin-bottom: 15px;
    letter-spacing: 1px;
    color: white !important;
}
.close-all {
    position: fixed;
    top: 20px;
    right: 30px;
    right: 15px;
    font-size: 9px;
    line-height: 16px;
    color: white !important;
    cursor: pointer;
    opacity: 0.5;
    transition: 250ms linear;
    &:hover {
        opacity: 1;
    }
}

height: 100vh;
animation: SlideInAbout .65s ease-in;
transition: 5s;
@keyframes SlideInAbout {
    from {
        min-height: 0;
        height: 0;
    }
    to {
        min-height: 100vh;
        height: 100vh;
    }
}
`;

export const Nav = styled.nav`
	min-height: 38px;


`;


// WEBPACK FOOTER //
// ./src/Styles/index.js